import { useEffect, useRef } from 'react';
import { Link } from 'react-router';
import logoPath from '../../assets/icons/logo-b.svg';
import contactIconPath from './images/ContactIcon.png';

const HeaderLp = () => {
    const dropdownRef = useRef<HTMLDetailsElement>(null);

    useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
          dropdownRef.current.open = false;
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return <header className="lg-header">
          <div className="lp-header-inner">
            <div className="lp-header-row">
              <div className="lp-header-nav">
                <a href="https://uk.getscanned.me/" className="logo-link" aria-label="Corevitals">
                  <img alt="" src={logoPath} />
                </a>

                <details className="contact-dropdown" ref={dropdownRef}>
                  <summary className="contact-button">
                    <img alt="" className="contact-icon" src={contactIconPath} />
                    <span>Contact Us</span>
                    <span className="lp-arrow-icon" aria-hidden="true">
                      ⌄
                    </span>
                  </summary>

                  <div className="dropdown-box-outer">
                    <nav className="dropdown-box" aria-label="Contact options">
                      <Link to="https://wa.me/+447447312364" target="_blank" rel="noopener">
                        WhatsApp
                      </Link>
                      <Link to="mailto:members@corevitals.me" target="_blank">
                        Email
                      </Link>
                    </nav>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </header>
}

export default HeaderLp;